const number = {
  currency: {
    style: 'currency',
    currency: 'BAM', // ISO 4217 BAM
    currencyDisplay: 'symbol' // Symbol KM
  },
  currencyNoDecimals: {
    style: 'currency',
    currency: 'BAM', // ISO 4217 BAM
    currencyDisplay: 'symbol', // Symbol KM
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  },
  numberNoDecimals: {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  },
  percent: {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }
}

const dateTime = {
  short: {
    year: 'numeric', month: 'numeric', day: 'numeric'
  }
}

const numberFormats = {
  en: number,
  bs: number
}

const dateTimeFormats = {
  en: dateTime,
  bs: dateTime
}

const currencyOverride = (parts, language) => {
  if (parts[0].type === 'currency') {
    const [currency, literal] = parts.splice(0, 2)

    currency.value = 'KM'
    parts.push(literal)
    parts.push(currency)
  } else {
    const currency = parts.find((part) => part.type === 'currency')
    currency.value = 'KM'
  }
}

export { numberFormats, dateTimeFormats, currencyOverride }
